import React from 'react';
import styled, { css } from 'styled-components';

import App from '../../../style/actionOnScroll/index';
import ContentServices from '../Services';
import theme from '../../../style/theme';
import OpenModal from '../../UI/Buttons/openModal';

let contNumber;

const AllSectionsStyles = styled.ul`
  margin: 0 auto 0 auto;
  padding: 0rem 1.5rem 0rem 1.5rem;
  max-width: ${theme.maxContainer.lg};
  position: relative;
`;

const BaseSectionStyles = styled.div`
  margin: 5rem auto 0 auto;
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
`;

const HexagonStyles = styled.div`
  ${(props) => {
    const { order } = props;
    return css`
      position: relative;
      display: flex;
      align-items: center;
      flex: 1 0 350px;
      max-width: 500px;
      order: ${order};
      width: 100%;
      @media (max-width: 820px) {
        flex: 1 0 400px;
        order: 0;
      }
      @media (max-width: 500px) {
        flex: 1 0 300px;
        order: 0;
      }
    `;
  }}
`;

const ContentTextStyle = styled.div`
  ${(props) => {
    const { order } = props;
    return css`
      flex: 1 0 380px;
      margin: 4rem 0rem 0rem 0rem;
      width: 100%;
      max-width: 50ch;
      order: ${order};
      @media (max-width: 820px) {
        flex: 1 0 400px;
        order: 0;
      }
      @media (max-width: 500px) {
        flex: 1 0 300px;
        order: 0;
      }
    `;
  }}
`;

const IntersectionStyle = styled.div`
  flex-grow: 1;
  order: 0;
  display: none;
  @media (min-width: 820px) {
    display: flex;
  }
`;

const Description = styled.div`
  max-width: 500px;
`;

const ButtonStyle = styled.div`
  display: flex;
  margin-top: 1.5rem;
`;

const renderSections = (section, dataForm) => {
  contNumber += 1;

  let sideChoiceNumber;
  let RotationFrom;
  let RotationTo;
  const hexagonID = "hexagon_Nunber_" + contNumber;

  sideChoiceNumber = (-1) ** contNumber;

  // Se item é a direita, sideChoiceNumber == (-1)^(número par)
  // Se item é a esquerda, sideChoiceNumber == (-1)^(número ímpar)

  // Rotacao dos hexagonos
  if (contNumber === 1) {
    RotationFrom = '55deg';
    RotationTo = '40deg';
  } else if (contNumber === 2) {
    RotationFrom = '-3deg';
    RotationTo = '12deg';
  } else if (contNumber === 3) {
    RotationFrom = '70deg';
    RotationTo = '55deg';
  } else if (contNumber === 4) {
    RotationFrom = '35deg';
    RotationTo = '50deg';
  } else if (contNumber === 5) {
    RotationFrom = '50deg';
    RotationTo = '35deg';
  }

  return (
    <BaseSectionStyles key={section.title} >
      <HexagonStyles order={sideChoiceNumber * -1} id={hexagonID} >
        {
          <App
            rotation_from={RotationFrom}
            rotation_to={RotationTo}
            color={section.hexagoncolor}
            icon={section.title}
            hexagonID={hexagonID}
          />
        }
      </HexagonStyles>
      <IntersectionStyle />
      <ContentTextStyle order={sideChoiceNumber}>
        <h2 >{section.title}</h2>
        <Description>
          {section.description.split('\n').map(item => (
            <p className="p_text" key={item.substr(0, 8)}>
              {item}
            </p>
          ))}
        </Description>
        <ContentServices {...section} />
        <ButtonStyle>
          <OpenModal
            formContent={dataForm}
            buttonCTA={section.cta}
            ctatype={section.ctatype}
            link={section.link}
            sectionID={section.sectionID}
            sectionTitle={section.title}
          />
        </ButtonStyle>
      </ContentTextStyle>
    </BaseSectionStyles>
  );
};
const Sections = (props) => {
  contNumber = 0;
  const sections = props.propSections;
  const dataForm = props.propDataForm;
  return (
    <AllSectionsStyles>
      <ul>
        {sections ? sections.map(section => renderSections(section, dataForm)) : ''}
      </ul>
    </AllSectionsStyles>
  );
};

export default Sections;



// WEBPACK FOOTER //
// ./src/components/Index/Sections/index.jsx